import styled from 'styled-components';
import { tokens } from '@servicetitan/tokens/core';

export const EllipseContainer = styled.div`
  position: relative;
`;

export const Ellipse = styled.div`
  position: absolute;
  right: calc(-7px - ${tokens.spacingHalf});
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: ${tokens.colorBlue500};

  // center the ellipse
  top: calc(50% - 3.5px);
`;
